import React, { useEffect, useState } from 'react';
import SelectAutoComplete from 'components/Tvendo/Common/SelectAutoComplete';
import RegularButton from 'components/CustomButtons/Button';
import Modal from 'components/Tvendo/Common/ModalBase';
import { wsGetAll, wsUpdate } from 'services/WService';

function CopyUserConfigurationModal(props) {
  const { model, setOpen } = props;
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState();
  const [processing, setProcessing] = useState(false);

  async function listUsers() {
    let res = await wsGetAll('oauth/user');
    if (res.success) {
      setUsers(res.data.filter((user) => user.type !== 'A'));
    }
  }

  async function copy() {
    setProcessing(true);
    let res = await wsUpdate('oauth/user/copy-roles', {
      user_id: model.id,
      to_user_id: selectedUser.id,
    });
    setProcessing(false);
    window.alert(res.message);
    if (res.success) {
      setOpen({ open: false });
    }
  }

  useEffect(() => {
    listUsers();
  }, []);

  return (
    <Modal
      title="Copiar configuración"
      maxWidth="sm"
      fullWidth
      model={props.model}
      setOpen={setOpen}
      entity=""
      disabledSave
      hideSave
      footerComponent={
        <RegularButton
          color="success"
          onClick={copy}
          disabled={processing || selectedUser === undefined}
        >
          Copiar
        </RegularButton>
      }
    >
      <SelectAutoComplete
        label="Usuario a copiar"
        required
        options={users}
        selectedOption={selectedUser}
        setSelectedOption={setSelectedUser}
        getOptionLabel={(user) => {
          return `${user.email} - ${user.name}`;
        }}
      />
    </Modal>
  );
}

export default CopyUserConfigurationModal;
